export default __webpack_public_path__ + "assets/apple-touch-icon-40x40-eec4d58.png";